export default __webpack_public_path__ + "static/media/regulatory--vehicles-carrying-dangerous-goods-only--g1.3a569021.png";